export default [
  {
    name: "CurricularUnit",
    backgroundColor: "#fff",
    hasLine: false,
    endpoint: "/course-unit/"
  }
];
